// Machine-drafted — review with a native speaker before launch.
const engagement = {
	engagement: {
		// Engagement page
		title: 'التفاعل',
		last7Days: 'آخر 7 أيام',
		last15Days: 'آخر 15 يومًا',
		last30Days: 'آخر 30 يومًا',
		last2Months: 'آخر شهرين',
		last6Months: 'آخر 6 أشهر',
		lastYear: 'العام الماضي',
		allCards: 'كل البطاقات',
		statContactEngagement: 'تفاعل جهات الاتصال',
		statEmailsOpened: 'رسائل مفتوحة',
		statCardsOpened: 'بطاقات مفتوحة',
		statTotalReactions: 'إجمالي التفاعلات',
		statTotalComments: 'إجمالي التعليقات',
		statTotalDownloads: 'إجمالي التنزيلات',
		cardEngagement: 'تفاعل البطاقة',
		noSentCards: 'لم يتم العثور على بطاقات مرسلة. أرسل بطاقة لعرض بيانات التفاعل.',
		untitled: 'بدون عنوان',
		cardAlt: 'بطاقة',
		loading: 'جارٍ التحميل...',
		analytics: 'التحليلات',
		reactions: 'التفاعلات',
		noReactions: 'لا توجد تفاعلات',
		comments: 'التعليقات (%{count})',
		anonymous: 'مجهول',
		noComments: 'لا توجد تعليقات',
		// Contacts engagement list
		viewContacts: 'عرض جهات الاتصال',
		cardStats: 'إحصائيات البطاقات',
		mostEngagedContacts: 'جهات الاتصال الأكثر تفاعلاً',
		noContactsYet: 'ليس لديك أي جهات اتصال بعد.',
		tooltipCardsOpened: 'إجمالي البطاقات التي فتحها جهة الاتصال هذه',
		tooltipCardsSent: 'إجمالي البطاقات المرسلة إلى جهة الاتصال هذه',
		// Activities
		typeLabel: 'النوع',
		optionClicks: 'النقرات',
		impression: 'الظهور',
		filterLabel: 'التصفية',
		optionLast10Days: 'آخر 10 أيام',
		optionLast7Days: 'آخر 7 أيام',
		newClick: '‘اسم الصورة’ حصل على نقرة جديدة',
		justNow: 'الآن',
		messengerRedirect: 'قام أحدهم من ماسنجر بالانتقال إلى www.cardclan.io',
		conversion: 'تحويل',
		sourceLabel: 'المصدر: %{source}',
		newImpression: '‘اسم الصورة’ حصل على ظهور جديد',
		oneHour: 'ساعة واحدة',
		twitterRedirect: 'قام أحدهم من تويتر بالانتقال إلى www.cardclan.io',
	} as Record<string, string>,
};
export default engagement;
